// Dev deployment: the API is a separate Azure Web App; calls are cross-origin.
export const environment = {
  apiBaseUrl: 'https://devapi.formgenerator.esignatur.dk',
};
